export const FIND_ALL_PRODUCTS = "FIND_ALL_PRODUCTS";
export const DETAIL_SINGLE_PRODUCT = "DETAIL_SINGLE_PRODUCT";
